import React from "react"
import { Link } from "react-router-dom"
import { makeStyles } from "@mui/styles"
import { ReactComponent as PhoneSvg } from "../assets/phonehandset.svg"
import { Container, Typography, Grid} from "@mui/material"

const useStyles = makeStyles((theme) => ({
  grid: {
    marginTop: 10,
    marginBottom: 15,
  },
  containerWrapper: {
    padding: theme.spacing(5),
    margin: "auto",
    backgroundColor: "#fafafa",
  },
  div: {
    backgroundColor: "#fafafa",
  },
  container: {
    textAlign: "left",
    marginBottom: theme.spacing(2),
  },
  copyright: {
    textAlign: "center",
    paddingBottom: theme.spacing(2),
  },
  svg: {
    width: "1vw",
    marginRight: 5,
  },
  svgGrid: {
    textAlign: "end",
    verticalAlign: "bottom",
    marginTop: 20,
    marginBottom: 20,
    marginRight: 50,
  },
}))

const Footer = () => {
  const classes = useStyles()
  return (
    <div className={classes.div}>
      <Container maxWidth="md" className={classes.containerWrapper}>
        {process.env.REACT_APP_MAINTENANCE !== "TRUE" && (
          <Grid
            container
            direction="row"
            justifyContent="space-evenly"
            spacing={1}
            className={classes.container}
          >
            <Grid item xs={2} className={classes.grid}>
              <Link to="/contact">
                <Typography align="center" display="block" variant="caption">
                  Contact us
                </Typography>
              </Link>
            </Grid>
            <Grid item xs={2} className={classes.grid}>
              <Link to="/privacy">
                <Typography align="center" display="block" variant="caption">
                  Privacy Policy
                </Typography>
              </Link>
            </Grid>
            <Grid item xs={2} className={classes.grid}>
              <Link to="/terms">
                <Typography align="center" display="block" variant="caption">
                  Terms & Conditions
                </Typography>
              </Link>
            </Grid>
          </Grid>
        )}
        <Grid
          container
          direction="row"
          alignItems="center"
          spacing={1}
          className={classes.container}
        >
          <Grid item xs={12}>
            <Typography
              display="block"
              gutterBottom
              variant="caption"
              className={classes.copyright}
            >
            Copyright © Phone Booth Game <PhoneSvg className={classes.svg} title={`Phone handset icon ${process.env.REACT_APP_COMMIT_REF}`} />
              <br/>
              {/* ABN 66 802 280 681 */}
            </Typography>
          </Grid>
          <Grid className={classes.copyright} item xs={12}>
            <Typography variant="caption" gutterBottom align="center">
            We respectfully acknowledge the Traditional Owners of the lands across the continent where
            this game is played. We particularly pay respect to the Traditional Owners
            of the land where this game was developed: the Gadigal people
            of the Eora nation, the Darkinjung people, and the Awabakal and Worimi people.
            Sovereignty has never
            been ceded. Always was, always will be, Aboriginal land.
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </div>
  )
}

export default Footer
